module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (230).032eb589.jpg";